import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { GlobalService } from '../global.service';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.sass']
})
export class NotificationComponent implements OnInit {
  public idsession;
  public id;
  public Messages;
  public Message;
  public notifications;
  public numberNotifications;
  public msgAvailable;
  public selectBan=atob(sessionStorage.getItem("selectBan"));
  public currentList;
  public postpago=false;
  public prepago=false;
  public telefoniaFijo=false;
  public totalAccountList;
  public token:string=sessionStorage.getItem("token");
  public tabActive='';
  constructor(public AngularFireAnalytics:AngularFireAnalytics, private route: ActivatedRoute,private router:Router,private services: Service,private loadingScreenService :LoadingScreenService, public global:GlobalService) {
    this.AngularFireAnalytics.setCurrentScreen("Tus Notificaciones");
    this.AngularFireAnalytics.logEvent("Tus Notificaciones-Screenview");
   }

  ngOnInit(){
    this.global.validateSession();
    //this.companyName=atob(sessionStorage.getItem("companyName"));
    this.Messages=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).Messages.MessagesList;
    console.log(this.Messages);
    
    this.notifications=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).Messages.MessagesList;
    this.numberNotifications=parseInt(JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).Messages.MessagesList.length);
    this.id=this.route.firstChild.snapshot.params.id;
    this.checkmsg();

    //this.getPersonalData(this.selectBan);
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
  checkmsg(){
    if(this.numberNotifications>0){
      this.msgAvailable=true; 
      if(parseInt(this.id)!=-1){
          //actualiza notificacion individual
          this.Message=this.Messages[this.id];
          this.updateNotif(this.Messages[this.id].id_message,this.Messages[this.id].account);
      }
      else{
          //actualizar todas las notificaciones
      }
    }
    else{
      this.msgAvailable=false;
        //no hay mensajes
    }
  }
  updateNotif(id,account){
    this.services.updMessageStatus(account,sessionStorage.getItem("token"),id).subscribe(data =>{
      if(data.hasError ==false){
        this.loadingScreenService.stopLoading();
        if(data.ErrorDesc!=''&&data.ErrorDesc!=undefined&&data.ErrorDesc!=null){
          this.global.notif(data.ErrorDesc);
        }
          // util.refreshDataTo(0, vm, $rootScope, userservice);
      }
      else{
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
      }
    });
  }
  getId(){
    if(this.route.firstChild){
      var id=this.route.firstChild.snapshot.params.id;
      if(id=='1'){
        this.idsession=1;
      }
      else if(id=='2'){
        this.idsession=2;
      }
      else if(id=='3'){
        this.idsession=3;
      }
      else if(id=='4'){
        this.idsession=4;
      }
      else if(id=='5'){
        this.idsession=5;
      }
      else{
        this.idsession=1;
        this.router.navigate(['profile']);
      }
    }
  }
}
